import { render, staticRenderFns } from "./appsMenu.vue?vue&type=template&id=741af254&"
import script from "./appsMenu.vue?vue&type=script&lang=js&"
export * from "./appsMenu.vue?vue&type=script&lang=js&"
import style0 from "./appsMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "appsMenu.vue"
export default component.exports